// // Variabile per il numero massimo di video disponibili
// let maxVideos = 2; // Sostituisci con il tuo numero
//
// // Variabile per tenere traccia del video corrente
// let currentVideo = 1;
//
// // Funzione per caricare e riprodurre il video
// function loadVideo() {
//     // URL del video corrente (sostituisci con il tuo formato)
//     // let videoUrl = `video-${currentVideo}.mp4`;
//     let videoUrl = `../../assets/video/video-${currentVideo}.mov`;
//
//     // Imposta il video corrente
//     let video = document.getElementById('heroVideo');
//     video.src = videoUrl;
//
//     // Calcola la durata del video una volta caricato
//     video.onloadedmetadata = function() {
//         console.log(`Durata del video ${currentVideo}: ${video.duration} secondi`);
//     };
//
//     // Cambia video quando finisce
//     video.onended = function() {
//         // Incrementa il numero del video
//         currentVideo++;
//
//         // Se tutti i video sono stati riprodotti, riparti dal primo
//         if (currentVideo > maxVideos) {
//             currentVideo = 1;
//         }
//
//         // Carica il nuovo video
//         loadVideo();
//     };
// }
//
// // Inizia con il primo video
// loadVideo();
